import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SettingsSideBar, { SettingsSideBarItem } from "./Components/SettingsSideBar";
import BasePage from "pages/UI/BasePage";
import SettingsCustomersPage from "./Components/SettingsCustomerPage";
import "./settingsPage.css";
import SettingsLandingPage from "./Components/SettingsLandingPage";
import SettingsPaySettingsPage from "./Components/SettingsPaySettingsPage";

const pageComponentMap: { [key: string]: React.ComponentType } = {
  Landing: SettingsLandingPage,
  Customers: SettingsCustomersPage,
  PaySettings: SettingsPaySettingsPage,
};

const SettingsPage = () => {
  const { t } = useTranslation("pages");

  const settingsSideBarItems: SettingsSideBarItem[] = [
    {
      key: "Customers",
      name: "settings.customers",
      parent: "super",
      forSuper: true
    },
    {
      key: "divider_1",
      name: "divider",
      parent: "super",
      forSuper: true
    },
    {
      key: "Pay",
      name: "settings.pay",
      parent: "super",
      forSuper: false
    },
    {
      key: "PaySettings",
      name: "settings.title",
      parent: "Pay",
      forSuper: false
    }
  ];

  const [activePageKey, setActivePageKey] = useState<string>("Landing");
  const ActivePageComponent = pageComponentMap[activePageKey];

  return (
    <BasePage className="settingsPage">
      <h1>{t("settings.title")}</h1>
      <div className="settings-layout">
        <div className="settings-layout__sidebar">
          <SettingsSideBar
            items={settingsSideBarItems}
            activeItemKey={activePageKey}
            onSelectItem={setActivePageKey}
          />
        </div>
        <div className="settings-layout__content">
          {ActivePageComponent && <ActivePageComponent />}
        </div>
      </div>
    </BasePage>
  );
};

export default SettingsPage;
